module.exports = __webpack_public_path__ + "static/media/gps_off.8c235aa3.svg";